import { GrupoAcessoEnum } from "@/core/domain/enums/seguranca/acesso/grupo-acesso.enum";

const GRUPOS_ACESSO_ELEVADO: ReadonlySet<GrupoAcessoEnum> = new Set([
    GrupoAcessoEnum.OWNER,
    GrupoAcessoEnum.DEVELOPER,
    GrupoAcessoEnum.SUPORT,
]);

export function isGrupoAcessoElevado(grupo?: GrupoAcessoEnum): boolean {
    return grupo != null && GRUPOS_ACESSO_ELEVADO.has(grupo);
}
